import React from 'react'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IMG_BASE_URL } from '../../../../config/Config';
import { Link } from 'react-router-dom';

const Home_Pandit_Chat_Call = (homeData) => {
    const live_pandit = homeData?.data?.live_pandit;
    const slidesToShow = live_pandit?.length < 4 ? live_pandit?.length : 4;

    const settings = {
        infinite: live_pandit?.length > slidesToShow,
        speed: 500,
        slidesToShow,
        slidesToScroll: 1,
        autoplay: live_pandit?.length > 1,
        autoplaySpeed: 2000,
        arrows: live_pandit?.length > 1,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: live_pandit?.length < 3 ? live_pandit?.length : 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: live_pandit?.length < 2 ? live_pandit?.length : 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div>
            <section className="gi-product-tab gi-products py-[40px] pb-[60px] bg-[#F6F6F6] max-[767px]:py-[30px] wow fadeInUp"
                data-wow-duration="2s">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div className="grid grid-cols-1 px-3 w-full">
                        <div className="gi-main-title text-center">
                            <div className="section-title">
                                <div className="section-detail">
                                    <h2 className="text-3xl bodonibook_font font-bold text-gray-900 relative inline capitalize">
                                        Pandit on <span className="text-[#9F2225]">Call & Chat</span></h2>
                                    <p className="mt-[5px] text-[14px] font-semibold text-gray-700 capitalize">13000+ Best Pandits</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="w-full mb-2 px-[15px] z-0">
                        {live_pandit?.length > 0 ? (
                            <Slider {...settings}>
                                {live_pandit?.map((astro_list_result, index) => (
                                    <div key={index} className="px-3 py-10">
                                        <Link to={`/pandit/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`} className="grid_call_chat w-full h-[350px]">
                                            <div className="gi-product-content">
                                                <div className="gi-product-inner transition-all duration-300 overflow-hidden rounded-lg bg-white shadow-custome">
                                                    {/* -- IMAGE SECTION -- */}
                                                    <div className="gi-pro-image-outer relative z-[11] pt-5">
                                                        <div className="gi-pro-image overflow-hidden">
                                                            <Link to={`/pandit/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`} className="block relative overflow-hidden">
                                                                <img
                                                                    className="main-images m-auto rounded-full h-[120px] w-[120px] transition-all duration-300"
                                                                    src={
                                                                        astro_list_result?.profile_image
                                                                            ? `${IMG_BASE_URL}${astro_list_result?.profile_image}`
                                                                            : Common_Images_Transport?.user_logo
                                                                    }
                                                                    alt={astro_list_result?.name}
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>

                                                    {/* -- CONTENT -- */}
                                                    <div className="gi-pro-content h-full p-3 pb-5 text-center">
                                                        <div className="gi-pro-rat-price pb-2 flex justify-center gap-2 items-center">
                                                            <span className="gi-pro-rating opacity-70">
                                                                {/* Static stars for now */}
                                                                {[...Array(5)].map((_, i) => {
                                                                    const full = Math.floor(astro_list_result?.average_rating);
                                                                    const isHalf = astro_list_result?.average_rating - full >= 0.5 && i === full;

                                                                    return (
                                                                        <span key={i} className="relative inline-block text-[14px] mr-[3px] w-[13px] h-[13px]">
                                                                            <i className="gicon gi-star text-gray-300 absolute top-0 left-0 w-full h-full" />
                                                                            {i < full && (
                                                                                <i className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full" />
                                                                            )}
                                                                            {isHalf && (
                                                                                <i
                                                                                    className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full overflow-hidden"
                                                                                    style={{ width: '50%' }}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                    );
                                                                })}
                                                            </span>
                                                            <span className="font-semibold text-[14px] text-white bg-red-400 px-3 rounded-full">
                                                                {astro_list_result?.average_rating > 0 ? astro_list_result?.average_rating.toFixed(1) : "0.0"}
                                                            </span>
                                                        </div>

                                                        <Link to={`/pandit/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`} >
                                                            <h5 className="text-gray-800 text-[15px] font-semibold capitalize">{astro_list_result?.name}</h5>
                                                        </Link>
                                                        <div className="my-2">
                                                            <div className="skills-container">
                                                                {astro_list_result?.skills && (
                                                                    <span
                                                                        className="line-clamp-1 text-gray-900 text-[12px] font-semibold text-center mt-2"
                                                                    >
                                                                        Skills: <span className='text-gray-600 font-medium'>{astro_list_result?.skills?.replace(/,/g, ", ")}</span>
                                                                    </span>
                                                                )}

                                                            </div>
                                                            <div className="language-container">
                                                                <span
                                                                    className="line-clamp-1 text-gray-900 text-[12px] font-semibold text-center mt-1 mb-2"
                                                                >
                                                                    Language: <span className='text-gray-600 font-medium'>{astro_list_result?.language?.replace(/,/g, ", ")}</span>
                                                                </span>
                                                            </div>
                                                            <span
                                                                className="text-gray-700 text-[12px] font-semibold px-3 py-1 text-center mt-2">Exp.<span className='text-gray-600 font-medium'>{astro_list_result?.experience} Yrs</span></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <div className='py-4 flex justify-center font-semibold'>
                                No Pandit Yet
                            </div>
                        )}

                    </div>
                    <div className="gi-pro-tab inline-block w-full text-center">
                        <Link to="/pandit-list" className="text-[13px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white">All Pandits</Link>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home_Pandit_Chat_Call